<div class="row" *ngIf="isComercial">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Presença de Sabugo/Pedúnculo</mat-label>
                <mat-select #txtPreSabPedun formControlName="presenca_sabugo_pedunculo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPresencaSabugoPedunculo($event.target.value)">
                  <mat-option *ngFor="let item of listPresencaSabugoPedunculo" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.presenca_sabugo_pedunculo)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Presença de Fundo</mat-label>
                <mat-select #txtPreFundo formControlName="presenca_fundo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPresencaFundo($event.target.value)">
                  <mat-option *ngFor="let item of listPresencaFundo" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.presenca_fundo)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Presença de Pó em Excesso</mat-label>
                <mat-select #txtPrePoExc formControlName="presenca_po_excesso" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPresencaPoExcesso($event.target.value)">
                  <mat-option *ngFor="let item of listPresencaPoExcesso" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.presenca_po_excesso)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Presença de Outros Cultivares</mat-label>
                <mat-select #txtOutCult formControlName="presenca_outros_cultivares" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPresencaOutrosCultivares($event.target.value)">
                  <mat-option *ngFor="let item of listPresencaOutrosCultivares" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.presenca_outros_cultivares)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-6 pt-3" *ngIf="!isBasic">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Total
                  Defeitos (g)</mat-label>
                <input matInput id="txtDef" #txtDef maxlength="10" formControlName="total_defeitos_g" currencyMask
                  (blur)="makeCalculations()" [ngClass]="{
                                InputBlockColor:
                                formulario.controls.total_defeitos_g.disabled
                                }" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"
                  *ngIf="!formulario.controls.total_defeitos_g.disabled">{{
                                hintNumber }}
                </mat-hint>
                <mat-hint align="end">{{ txtDef.value.length }}
                  / 10</mat-hint>
                <mat-error>{{
                                hasErrorFormControl(formulario.controls.total_defeitos_g)
                                }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3" *ngIf="!isBasic">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Total
                  Defeitos (%)</mat-label>
                <input matInput id="txtDefPorc" #txtDefPorc maxlength="10" formControlName="total_defeitos_prc"
                  currencyMask readonly class="InputBlockColor" />
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                              }}
                </mat-hint>
                <mat-hint align="end">{{ txtDefPorc.value.length
                              }} / 10</mat-hint>
                <mat-error>{{
                              hasErrorFormControl(formulario.controls.total_defeitos_prc)
                              }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peso
                  Hectolítrico Fração Boa (kg/hl)</mat-label>
                <input matInput id="txtPesoHectoFraBoa" #txtPesoHectoFraBoa maxlength="10"
                  formControlName="peso_hectolitrico_fracao_boa" currencyMask (blur)="makeCalculations()" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                            }}
                </mat-hint>
                <mat-hint align="end">{{
                            txtPesoHectoFraBoa.value.length }} / 10</mat-hint>
                <mat-error>{{
                            hasErrorFormControl(
                            formulario.controls.peso_hectolitrico_fracao_boa
                            )
                            }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peso
                  Hectolítrico Fração Descarte-COLUNA DE AR(kg/hl)</mat-label>
                <input matInput id="txtHectoFraDesc" #txtHectoFraDesc maxlength="10"
                  formControlName="peso_hectolitrico_fracao_descarte" currencyMask (blur)="makeCalculations()" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                          }}
                </mat-hint>
                <mat-hint align="end">{{
                          txtHectoFraDesc.value.length }} / 10</mat-hint>
                <mat-error>
                  {{
                          hasErrorFormControl(
                          formulario.controls.peso_hectolitrico_fracao_descarte
                          )
                          }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Diferença de
                  Peso Hectolítrico</mat-label>
                <input matInput id="txtDifPesoHecto" #txtDifPesoHecto maxlength="10"
                  formControlName="diferenca_peso_hectolitrico" currencyMask readonly class="InputBlockColor" />
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                        }}
                </mat-hint>
                <mat-hint align="end">{{
                        txtDifPesoHecto.value.length }} / 10</mat-hint>
                <mat-error>{{
                        hasErrorFormControl(
                        formulario.controls.diferenca_peso_hectolitrico
                        )
                        }}
                </mat-error>
              </mat-form-field>
            </div>



          </div>

        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>

<div class="row" *ngIf="isBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Presença de Sabugo/Pedúnculo</mat-label>
                <mat-select #txtPreSabPedun formControlName="presenca_sabugo_pedunculo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPresencaSabugoPedunculo($event.target.value)">
                  <mat-option *ngFor="let item of listPresencaSabugoPedunculo" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.presenca_sabugo_pedunculo)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Presença de Fundo</mat-label>
                <mat-select #txtPreFundo formControlName="presenca_fundo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPresencaFundo($event.target.value)">
                  <mat-option *ngFor="let item of listPresencaFundo" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.presenca_fundo)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Presença de Pó em Excesso</mat-label>
                <mat-select #txtPrePoExc formControlName="presenca_po_excesso" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPresencaPoExcesso($event.target.value)">
                  <mat-option *ngFor="let item of listPresencaPoExcesso" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.presenca_po_excesso)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Presença de Outros Cultivares</mat-label>
                <mat-select #txtOutCult formControlName="presenca_outros_cultivares" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPresencaOutrosCultivares($event.target.value)">
                  <mat-option *ngFor="let item of listPresencaOutrosCultivares" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.presenca_outros_cultivares)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Existe Descarte na Massa Boa?</mat-label>
                <mat-select #txtExisteDescarteMassaBoa formControlName="existe_descarte_massa_boa"
                  disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPresencaOutrosCultivares($event.target.value)">
                  <mat-option *ngFor="let item of listPresencaOutrosCultivares" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.existe_descarte_massa_boa)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3" *ngIf="!isBasic">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Total
                  Defeitos (g)</mat-label>
                <input matInput id="txtDef" #txtDef maxlength="10" formControlName="total_defeitos_g" currencyMask
                  (blur)="makeCalculations()" [ngClass]="{
                                InputBlockColor:
                                formulario.controls.total_defeitos_g.disabled
                                }" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"
                  *ngIf="!formulario.controls.total_defeitos_g.disabled">{{
                                hintNumber }}
                </mat-hint>
                <mat-hint align="end">{{ txtDef.value.length }}
                  / 10</mat-hint>
                <mat-error>{{
                                hasErrorFormControl(formulario.controls.total_defeitos_g)
                                }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3" *ngIf="!isBasic">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Total
                  Defeitos (%)</mat-label>
                <input matInput id="txtDefPorc" #txtDefPorc maxlength="10" formControlName="total_defeitos_prc"
                  currencyMask readonly class="InputBlockColor" />
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                              }}
                </mat-hint>
                <mat-hint align="end">{{ txtDefPorc.value.length
                              }} / 10</mat-hint>
                <mat-error>{{
                              hasErrorFormControl(formulario.controls.total_defeitos_prc)
                              }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peso
                  Hectolítrico Fração Boa (kg/hl)</mat-label>
                <input matInput id="txtPesoHectoFraBoa" #txtPesoHectoFraBoa maxlength="10"
                  formControlName="peso_hectolitrico_fracao_boa" currencyMask (blur)="makeCalculations()" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                            }}
                </mat-hint>
                <mat-hint align="end">{{
                            txtPesoHectoFraBoa.value.length }} / 10</mat-hint>
                <mat-error>{{
                            hasErrorFormControl(
                            formulario.controls.peso_hectolitrico_fracao_boa
                            )
                            }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peso
                  Hectolítrico Fração Descarte-COLUNA DE AR(kg/hl)</mat-label>
                <input matInput id="txtHectoFraDesc" #txtHectoFraDesc maxlength="10"
                  formControlName="peso_hectolitrico_fracao_descarte" currencyMask (blur)="makeCalculations()" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                          }}
                </mat-hint>
                <mat-hint align="end">{{
                          txtHectoFraDesc.value.length }} / 10</mat-hint>
                <mat-error>
                  {{
                          hasErrorFormControl(
                          formulario.controls.peso_hectolitrico_fracao_descarte
                          )
                          }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Diferença de peso hectolítrico (%)</mat-label>
                <input matInput id="txtDifPesoHecto" #txtDifPesoHecto maxlength="10"
                  formControlName="diferenca_peso_hectolitrico" currencyMask readonly class="InputBlockColor" />
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                        }}
                </mat-hint>
                <mat-hint align="end">{{
                        txtDifPesoHecto.value.length }} / 10</mat-hint>
                <mat-error>{{
                        hasErrorFormControl(
                        formulario.controls.diferenca_peso_hectolitrico
                        )
                        }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Realiza calculo automático-->
            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Resultado</mat-label>
                <input matInput id="txtResultado" #txtResultado maxlength="50" formControlName="resultado" readonly
                  class="InputBlockColor" />
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                      }}
                </mat-hint>

                <mat-error>{{
                      hasErrorFormControl(
                      formulario.controls.resultado
                      )
                      }}
                </mat-error>
              </mat-form-field>
            </div>



          </div>

        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>